import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';

const CompletionStatus: React.FC<{ isCompleted?: boolean } & React.ComponentProps<typeof Box>> = ({
  isCompleted,
  className,
  ...rest
}) => {
  return (
    <Box
      className={cn(
        'h-8 w-8 rounded-full',
        { 'bg-bg-success': isCompleted },
        { border: !isCompleted },
        className,
      )}
      {...rest}
    />
  );
};

export default CompletionStatus;
